<template>
  <account-model
    :title="''"
    :hasFooter="false"
    :modelStyles="{'width': '444px'}"
    :titleStyles="{'font-size': '16px', 'font-weight': 'normal', 'background': '#fff'}"
    @closeModel="closeModel"
  >
    <div
      class="success-wrapper"
      slot="content"
    >
      <!-- 直接退费流程结果 -->
      <div
        class="pay-money"
        v-if="this.dropDialog.type == 1"
      >
        <img src="../../assets/img/icon_success.png">
        <p class="success-title">提交成功</p>
        <p class="pay">应退金额<span class="red">￥</span><span class="bold">{{this.dropDialog.totalPrice}}</span></p>
        <div v-if="this.dropDialog.payTypes && this.dropDialog.payTypes.length > 0">
          <div
            v-for="(item, index) in this.dropDialog.payTypes"
            :key="index"
          >
            <p class="copy">{{item.msg}}</p>
          </div>
        </div>
      </div>
      <!-- 退费申请中 -->
      <div
        class="pay-money"
        v-if="this.dropDialog.type == 2"
      >
        <img
          src="../../assets/img/icon_chenggong.png"
          alt=""
        >
        <p>退课审核中，请耐心等待</p>
        <p class="pay">应退金额 <span class="red">￥</span><span class="bold">{{this.dropDialog.totalPrice}}</span></p>
        <p
          class="copy"
          v-if="this.dropDialog.productMsg != ''"
        >{{this.dropDialog.productMsg}}</p>
      </div>
      <div class="pay-done">
        <a @click="closeSubmit">完成</a>
      </div>
    </div>
  </account-model>
</template>

<script>
import accountModel from '@/components/sub/accountModel.vue'
import axios from '~common/assets/js/ocenter-axios.js'
export default {
  name: 'submitSuccess',
  props: ['dropDialog'],
  data () {
    return {
    }
  },
  components: {
    accountModel
  },
  methods: {
    closeModel () {
      this.$emit('closeDropPhoneDialog')
      // 跳转到订单列表页
      this.$router.go(-1)
    },
    closeSubmit () {
      this.$emit('closeDropPhoneDialog')
      // 跳转到订单列表页
      this.$router.go(-1)
    }
  }
}
</script>

<style lang='less' scoped>
.success-wrapper {
  padding: 20px;
  // height: 240px;
  position: relative;
  font-size: 14px;
  box-sizing: border-box;
  color: #666666;
  text-align: center;
  &:after {
    content: "";
    display: block;
    clear: both;
  }
  .pay-money {
    font-weight: 400;
    font-size: 16px;
    font-family: PingFangSC-Regular;
    .success-title {
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 14px;
    }
    .bold {
      font-size: 24px;
      font-weight: 500;
      color: rgba(255, 94, 80, 1);
    }
    .red {
      font-weight: 500;
      color: rgba(241, 50, 50, 1);
      font-size: 14px;
    }
    .pay {
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
      margin-bottom: 3px;
      // margin-bottom: 16px;
      margin-top: 16px;
    }
    .copy {
      margin-top: 1px;
      font-size: 12px;
      color: rgba(153, 153, 153, 1);
    }
  }
  .pay-done {
    margin-bottom: 10px;
    a {
      cursor: pointer;
      margin-top: 40px;
      display: block;
      width: 130px;
      height: 40px;
      background: rgba(241, 50, 50, 1);
      border-radius: 2px;
      margin-left: 117px;
      text-align: center;
      line-height: 40px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// module/order/src/components/dialog/dropPriceDialog.vue